
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { CertificationService } from '../../../../services/certification/certification.service';
import { SupplierService } from '../../../../services/supplier/supplier.service';

@Component({
  selector: 'app-supplier-certification-form',
  templateUrl: './supplier-certification-form.component.html',
  styles: ['label.required:after {top: 0}']
})
export class SupplierCertificationFormComponent implements OnInit {

  @Output() onUpdateElement: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();

  addEditFormSupCert: FormGroup;

  certs_items: Array<{value: number, label: string}>;
  selected_cert: any;

  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    public supplierService: SupplierService,
    private svcCerts: CertificationService) {
  }

  ngOnInit(): void {

    this.certs_items = sessionStorage.getItem('supplierCerts') ? JSON.parse(sessionStorage.getItem('supplierCerts')) : [{value: null, label: ''}];

    this.supplierService.getFieldsCertification().subscribe(res => {
      this.fields = res;
    });

    if (!sessionStorage.getItem('supplierCerts')) {
      this.svcCerts.getAll().subscribe(
        res => {
          this.svcCerts.certifications.forEach(c => {
            this.certs_items.push({
              label: c.code,
              value: c.id
            })
          }
          );
        },
        error => console.error(error),
        () => sessionStorage.setItem('supplierCerts', JSON.stringify(this.certs_items))
      );
    }

    this.addEditFormSupCert = this.fb.group({
      'certification_id': new FormControl(null)
    });

  }

  saveOrUpdate(): void {

    if (!this.addEditFormSupCert.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    this.onAddElement.emit( {
      certification_id: this.selected_cert
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-certification/supplier-certification-form.component.ts